// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");

function ToggleMandatory(props) {
  var onMandatoryChange = props.onMandatoryChange;
  var mandatory = props.mandatory;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: "Mandatory",
                                  className: "text-darkcharcoal text-sm font-medium"
                                }),
                            JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                  checked: mandatory,
                                  handleChange: (function (param) {
                                      Curry._1(onMandatoryChange, !mandatory);
                                    }),
                                  labelClassName: "flex items-center"
                                })
                          ],
                          className: "flex justify-between"
                        }),
                    className: "mb-4 pb-4 border-b border-gray-300"
                  })
            });
}

var make = ToggleMandatory;

exports.make = make;
/* react/jsx-runtime Not a pure module */
